import {
  callGetWordOnline,
  callGetExcelOnline,
  callAddVersion,
  callGetVersion,
} from "@/api/word-online";
import Vue from "vue";

const getWordOnline = async (_, payload) => {
  try {
    return callGetWordOnline(payload);
  } catch (error) {
    if (error.response.data.messages) {
      Vue.$toast.error(error.response.data.messages[0]);
    } else {
      Vue.$toast.error(error);
    }
  }
};

const getExcelOnline = async (_, payload) => {
  try {
    return callGetExcelOnline(payload);
  } catch (error) {
    if (error.response.data.messages) {
      Vue.$toast.error(error.response.data.messages[0]);
    } else {
      Vue.$toast.error(error);
    }
  }
};

const AddVersion = async (_, payload) => {
  const response = await callAddVersion(payload.data);
  if (response && response.data.IsSuccess) {
    Vue.toasted.global.showSuccessMessage({
      message: "Thêm phiên bản mới thành công",
    });
    payload.onSuccess && payload.onSuccess();
  } else {
    Vue.toasted.global.showErrorMessage({
      message: response.data.Messages[0],
    });
  }
};

const getVersion = async (context, payload) => {
  try {
    const response = await callGetVersion(payload);
    if (response && response.data.IsSuccess) {
      context.commit("SET_VERSION_WORD", response.data.Data);
    } else {
      Vue.toasted.global.showErrorMessage({
        message: response.data.Messages[0],
      });
    }
  } catch (error) {
    console.log(error);
  }
};



export default {
  getExcelOnline,
  getWordOnline,
  AddVersion,
  getVersion,
};
